import api from './AxiosInstance';

export class AffectationActeService {
  
    getAllAffectationActe = async (codespe) => {
        try {
          const response = await api.get(`Actes/Affect/list/${codespe}`, {
           
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          throw error;
        }
      };

      getAllAffectActe = async () => {
        try {
          const response = await api.get(`/Actes/list`, {
           
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          throw error;
        }
      };

 
    
   addAffectationActe = async ( newCreation) => {
    try {
    
  
      const response = await api.post(`/Actes/Affect/add`, newCreation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
   
      throw error;
    }
  };
  updateAffectationActe = async ( newCreation) => {
    try {
    
  
      const response = await api.put(`/Actes/Affect/update`, newCreation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
   
      throw error;
    }
  };
  updateAffctation =async (newCreation)=>{
    //
    try {


      const response = await api.put(`/Actes/update/Exclusion`, newCreation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
   
      throw error;
    }
  }

  deleteAffctation =async (newCreation)=>{
   
    try {


      const response = await api.post(`/Actes/Affect/delete`, newCreation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
   
      throw error;
    }
  }

  deleteAffctationlines =async (newCreation)=>{
   
    try {


      const response = await api.post(`/Actes/Affect/list/delete`, newCreation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
   
      throw error;
    }
  }
 
 

  /* updateCreation = async (updatedData) => {
    try {
     

      const response = await api.put(`/Actes/update`, updatedData)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteCreation = async () => {
    try {
    
      const response = await api.post(`/Actes/delete`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };  */
}


